<template>

    <div class="relative">
        <div class="bg-gray-300 bg-auto bg-no-repeat bg-right-bottom min-h-screen mt-0 px-2 md:px-0 pt-20 pb-20"
            :style="{ backgroundImage: 'url(' + require('../assets/img/undraw_air_support_wy1q.svg') + ')' }">
            <div class="container mx-auto py-5">
                <h2 class="h-18 text-blue-500 text-4xl lg:text-5xl font-bold leading-tight my-4">您的下一個目的地？</h2>
                <div class="border m-10 rounded-lg bg-white mx-auto shadow-lg rounded-lg">
                    <div class="sm:flex sm:items-center px-6 py-3">
                        <form class="w-full">
                            <div class="flex flex-wrap -mx-3 mb-6">
                                <div class="w-full lg:w-1/5 px-0 mb-6 lg:mb-0">
                                    <label class="inline-flex items-center mr-5 cursor-pointer">
                                        <input type="radio"
                                            class="form-radio w-5 h-5 border-gray-200 bg-gray-200 cursor-pointer"
                                            name="tripType"
                                            value="return"
                                            :checked="tripType == 'return'"
                                            @click="updateTripType('return')">
                                        <span class="ml-2">往返</span>
                                    </label>
                                    <label class="inline-flex items-center cursor-pointer">
                                        <input type="radio"
                                            class="form-radio w-5 h-5 border-gray-200 bg-gray-200 cursor-pointer"
                                            name="tripType"
                                            :checked="tripType == 'one-way'"
                                            @click="updateTripType('one-way')">
                                        <span class="ml-2">單程</span>
                                    </label>
                                </div>
                            </div>
                            <div class="flex flex-wrap -mx-3 mb-2">
                                <div class="relative w-full lg:w-1/5 px-0 mb-6 lg:mb-0">
                                    <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-first-name">
                                        從
                                    </label>
                                    <input class="appearance-none block w-full h-16 bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                        id="grid-first-name"
                                        type="text"
                                        placeholder="國家/地區、城市或機場"
                                        :value="originSearch"
                                        v-on:focus="changeOriginSearchFocused( true )"
                                        v-on:blur="changeOriginSearchFocused( false )"
                                        v-on:input="searchPlacesForOrigin($event)">
                                    <div class="absolute min-w-full shadow-md rounded h-16 py-2 bg-blue-500 hover:bg-blue-600 leading-tight z-10 cursor-pointer" v-show="!!originSearchFocused && originPlacesFiltered.length == 0">
                                        <div class="min-w-full clearfix">
                                            <div class="float-left py-3 px-2">
                                                <i class="text-3xl text-white fas fa-globe"></i>
                                            </div>
                                            <div class="float-left text-white">
                                                <div class="block min-w-full py-1 px-2 text-base leading-tight">
                                                    無法確定出發地？
                                                </div>
                                                <div class="block py-1 px-2 text-xs leading-tight">
                                                    請在此處輸入出發地
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="absolute min-w-full shadow-md rounded bg-white z-10" v-show="!!originSearchFocused && originPlacesFiltered.length > 0">
                                        <ul>
                                            <li class="block min-w-full h-16 py-2 text-gray-700 border border-gray-200 hover:bg-gray-200 leading-tight cursor-pointer"
                                                style="width:400px;"
                                                v-for="(place, idx) of originPlacesFiltered"
                                                :key="idx"
                                                @click="selectOriginPlace(place)"
                                                >
                                                <div class="min-w-full clearfix">
                                                    <div class="float-left py-3 px-2">
                                                        <i class="text-3xl text-gray-400 fas"
                                                            :class="{
                                                                'fa-flag': place.place_type == 'country',
                                                                'fa-building': place.place_type == 'city',
                                                                'fa-plane': place.place_type == 'airport',
                                                                'fa-map-marker': place.place_type == 'anywhere'
                                                            }"></i>
                                                    </div>
                                                    <div class="float-left text-gray-700">
                                                        <div class="block min-w-full py-1 px-4 text-lg  leading-tight">
                                                            {{ place.place_name }} ({{ place.place_id }})
                                                        </div>
                                                        <div class="block py-1 px-4 text-sm leading-tight">
                                                            {{ place.country_name }}
                                                        </div>
                                                    </div>
                                                </div>

                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="relative w-full lg:w-1/5 px-0 mb-6 lg:mb-0">
                                    <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-last-name">
                                        到
                                    </label>

                                    <input class="appearance-none block w-full h-16 bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                        id="grid-first-name"
                                        type="text"
                                        placeholder="國家/地區、城市或機場"
                                        :value="destinationSearch"
                                        v-on:focus="changeDestinationSearchFocused( true )"
                                        v-on:blur="changeDestinationSearchFocused( false )"
                                        v-on:input="searchPlacesForDestination($event)">
                                    <div class="absolute min-w-full shadow-md rounded h-16 py-2 bg-blue-500 hover:bg-blue-600 leading-tight z-10 cursor-pointer" v-show="!!destinationSearchFocused && destinationPlacesFiltered.length == 0">
                                        <div class="min-w-full clearfix">
                                            <div class="float-left py-3 px-2">
                                                <i class="text-3xl text-white fas fa-globe"></i>
                                            </div>
                                            <div class="float-left text-white">
                                                <div class="block min-w-full py-1 px-2 text-base leading-tight">
                                                    無法確定目的地？
                                                </div>
                                                <div class="block py-1 px-2 text-xs leading-tight">
                                                    請在此處輸入目的地
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="absolute min-w-full shadow-md rounded bg-white z-10" v-if="!!destinationSearchFocused && destinationPlacesFiltered.length > 0">
                                        <ul>

                                                <li class="block min-w-full h-16 py-2 text-gray-700 border border-gray-200 hover:bg-gray-200 leading-tight cursor-pointer"
                                                    style="width:400px;"
                                                    v-for="(place, idx) of destinationPlacesFiltered"
                                                    :key="idx"
                                                    @click="selectDestinationPlace(place)"
                                                    >
                                                    <div class="min-w-full clearfix">
                                                        <div class="float-left py-3 px-2">
                                                            <i class="text-3xl text-gray-400 fas"
                                                            :class="{
                                                                'fa-flag': place.place_type == 'country',
                                                                'fa-building': place.place_type == 'city',
                                                                'fa-plane': place.place_type == 'airport',
                                                                'fa-map-marker': place.place_type == 'anywhere'
                                                            }"></i>
                                                        </div>
                                                        <div class="float-left text-gray-700">
                                                            <div class="block min-w-full py-1 px-4 text-lg  leading-tight">
                                                                {{ place.place_name }} ({{ place.place_id }})
                                                            </div>
                                                            <div class="block py-1 px-4 text-sm leading-tight">
                                                                {{ place.country_name }}
                                                            </div>
                                                        </div>
                                                    </div>

                                                </li>

                                        </ul>
                                    </div>
                                </div>
                                <div class="w-full lg:w-1/5 px-0">
                                    <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-last-name">
                                        去程
                                    </label>
                                    <Datepicker input-class="appearance-none block w-full h-16 bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                                :format="'yyyy-MM-dd'"
                                                :disabled-dates="disabledDates"
                                                :value="outboundDate"
                                                @selected="updateOutboundDate"
                                                 />
                                    <!--
                                        <input class="appearance-none block w-full h-16 bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                        type="date"
                                        :min="transformDateToYMD(today)"
                                        :max="transformDateToYMD(afterOneYear)"
                                        :value="outboundDate"
                                        @change="updateOutboundDate">
                                    -->
                                </div>
                                <div class="w-full lg:w-1/5 px-0" @click=" updateTripType('return') ">
                                    <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                                        :class="{
                                            'opacity-50': tripType == 'one-way'
                                        }">
                                        回程
                                    </label>
                                    <input class="appearance-none block w-full h-16 bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 disabled:opacity-50"
                                        id="grid-last-name"
                                        type="text"
                                        disabled="disabled"
                                        value="（單程）"
                                        v-show=" tripType == 'one-way' ">
                                    <Datepicker input-class="appearance-none block w-full h-16 bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                                :format="'yyyy-MM-dd'"
                                                :disabled-dates="disabledDates"
                                                :value="inboundDate"
                                                @selected="updateInboundDate"
                                                v-show=" tripType != 'one-way' "
                                                 />
                                    <!--
                                    <input class="appearance-none block w-full h-16 bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 disabled:opacity-50"
                                        id="grid-last-name"
                                        type="date"
                                        :min="transformDateToYMD(today)"
                                        :max="transformDateToYMD(afterOneYear)"
                                        :value="inboundDate"
                                        @change="updateInboundDate"
                                        v-show=" tripType != 'one-way' ">
                                    -->
                                </div>
                                <div class="relative w-full lg:w-1/5 px-0 mb-6 lg:mb-0 outline-none"
                                    tabindex="0"
                                    v-on:focus="changeTravellerFocused( true )" >
                                    <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-last-name">
                                        客艙等級及旅客
                                    </label>
                                    <div class="appearance-none block w-full h-16 bg-gray-200 text-gray-700 border border-gray-200 rounded py-6 px-4 leading-tight cursor-pointer"
                                        @click.self="changeTravellerFocused( !formOfTravellerDataFocused )">
                                        {{ adults + children.length }} 旅客，{{ getCabinClassName( cabinClass ) }}
                                    </div>
                                    <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-4 text-gray-700">
                                        <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                                    </div>
                                    <div class="absolute w-full shadow-md rounded bg-white px-3 z-20 ml-auto lg:-ml-24 xl:-ml-16" v-show="formOfTravellerDataFocused "
                                        style="min-width:320px;">
                                        <form class="min-w-full ">
                                            <div class="flex flex-wrap mb-2">
                                                <div class="relative w-full px-0 mb-6 lg:mb-0">
                                                    <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-last-name">
                                                        客艙等級及旅客
                                                    </label>
                                                    <select class="block appearance-none w-full h-10 bg-gray-200 border border-gray-200 text-gray-700 py-1 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                                            id="grid-state"
                                                            @change="updateCabinClass($event)">
                                                        <option v-for="(cabinClassName, cabinClassKey) in cabinClasses"
                                                            :value="cabinClassKey"
                                                            :key="cabinClassKey"
                                                            :selected="cabinClassKey == cabinClass">
                                                            {{ cabinClassName }}
                                                        </option>
                                                    </select>
                                                    <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                                        <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="flex flex-wrap mb-1">
                                                <div class="w-full px-0 mb-1 lg:mb-0">
                                                    <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-last-name">
                                                        大人
                                                    </label>
                                                    <button type="button" class="w-10 h-10 rounded-full bg-blue-500 text-white disabled:opacity-50 text-2xl leading-tight font-bold my-2"
                                                        :disabled="adults == 0"
                                                        @click="updateAdults(-1)">
                                                        -
                                                    </button>
                                                    <span class="mx-4 my-2 text-xl ">
                                                        {{ adults }}
                                                    </span>
                                                    <button type="button" class="w-10 h-10 rounded-full bg-blue-500 text-white disabled:opacity-50 text-2xl leading-tight font-bold my-2"
                                                        :disabled="adults >= 8"
                                                        @click="updateAdults(+1)">
                                                        +
                                                    </button>
                                                    <span class="mx-2 my-2 text-lg">年滿16歲</span>
                                                </div>
                                            </div>
                                            <div class="flex flex-wrap mb-1">
                                                <div class="w-full px-0 mb-1 lg:mb-0">
                                                    <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-last-name">
                                                        孩童
                                                    </label>
                                                    <button type="button" class="w-10 h-10 rounded-full bg-blue-500 text-white disabled:opacity-50 text-2xl leading-tight font-bold my-2"
                                                        :disabled="children.length == 0"
                                                        @click="removeChild">
                                                        -
                                                    </button>
                                                    <span class="mx-4 my-2 text-lg">
                                                        {{ children.length }}
                                                    </span>
                                                    <button type="button" class="w-10 h-10 rounded-full bg-blue-500 text-white disabled:opacity-50 text-2xl leading-tight font-bold my-2"
                                                        :disabled="children.length >= 8"
                                                        @click="addChild">
                                                        +
                                                    </button>
                                                    <span class="mx-2 my-2 text-lg">0-15歲</span>
                                                </div>
                                            </div>
                                            <div class="flex flex-wrap mb-2">
                                                <div class="relative w-full px-0 mb-2 lg:mb-0"
                                                    v-for="(child, idx) in children"
                                                    :key="idx">
                                                    <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-last-name">
                                                        第 {{ idx + 1 }} 名兒童的年齡
                                                    </label>
                                                    <select class="block appearance-none w-full h-10 bg-gray-200 border border-gray-200 text-gray-700 py-1 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                                        @change="setChildAge(idx, $event)">
                                                        <option>選擇年齡</option>
                                                        <option v-for="age in 16"
                                                            :value="age - 1"
                                                            :key="age - 1"
                                                            :selected="child.years === age - 1 ">
                                                            {{ age - 1 }}
                                                        </option>
                                                    </select>
                                                    <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                                        <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="flex flex-wrap mb-2">
                                                <div class="w-full px-0 mb-1 lg:mb-0">
                                                    <ul>
                                                        <li class="w-full my-2 text-xs text-gray-500 leading-tight">
                                                            旅行時，您須符合預訂規定的年齡層。航空公司對於未滿 18 歲單獨旅行的乘客有限制規定。
                                                        </li>
                                                        <li class="w-full my-2 text-xs text-gray-500 leading-tight">
                                                            年齡限制與攜兒童旅行的政策可能不同，請先向航空公司確認，然後再進行預訂。
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div class="flex flex-row-reverse flex-wrap border-t-2 border-gray-200">
                                                <button type="button"
                                                        class="mb-2 lg:mb-0 p-2 text-blue-500"
                                                        @click="changeTravellerFocused( false )">
                                                    完成
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <div class="flex flex-wrap flex-row-reverse -mx-3">
                                <div class="w-full lg:w-1/5 px-0 mb-6 lg:mb-0">
                                    <button type="button"
                                            class="w-full flex justify-center h-16 bg-blue-500 rounded px-4 mb-3 leading-tight focus:outline-none focus:bg-blue-600 text-white text-2xl font-bold"
                                            :disabled="isLoading"
                                            @click="queryPrice">
                                        <Spin :color="'white'"
                                            v-show="isLoading">
                                        </Spin>
                                        <span v-show="!isLoading">
                                            搜尋航班
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="flex flex-wrap justify-end">
                    <img class="w-5/12 md:w-2/12" src="../assets/img/skyscanner-inline--blue.svg"/>
                </div>
            </div>
        </div>
        <div class="absolute w-full bottom-0 py-2 z-10">
            <p class="text-xs text-gray-500 text-center">© Copyright 2020, Aerobile Travel</p>
        </div>
        <WarningMessage :messages="warningMessages"
                        v-show="warningMessages.length"
                        v-on:confirm="clearWarningMessages"/>

        <ErrorMessage :messages="errorMessages"
                        v-show="errorMessages.length"
                        v-on:confirm="clearErrorMessages"/>
    </div>

</template>

<script>
import { mapState, mapGetters } from 'vuex'
import api from '../api/index';
import utils from '../utils';
import Datepicker from 'vuejs-datepicker';
import Spin from './Spin';
import WarningMessage from './WarningMessage.vue';
import ErrorMessage from './ErrorMessage.vue';

export default {
  components:{
      Datepicker,
      Spin,
      WarningMessage,
      ErrorMessage
  },
  data(){
      return {

          now: new Date,

          today: (function(){
              let date = new Date;
              date.setHours(0);
              date.setMinutes(0);
              date.setSeconds(0);
              date.setMilliseconds(0);
              return date;
          }()),

          afterOneYear: (function(){
              let date = new Date;
              date.setYear(date.getFullYear()+1);
              date.setHours(0);
              date.setMinutes(0);
              date.setSeconds(0);
              date.setMilliseconds(0);
              return date;

          }()),

          timerForOriginSearch:null,
          timerForDestinationSearch:null,
      };
  },
  computed: {

    disabledDates(){
        return {
            to: this.today,
            from: this.afterOneYear,
        };
    },

    ...mapState({

        cabinClasses: state => state.search.cabinClasses,

        warningMessages: state => state.search.warningMessages,
        errorMessages:   state => state.search.errorMessages,

        originSearch: state => state.search.originSearch,
        originSearchFocused: state => state.search.originSearchFocused,
        originPlacesFiltered: state => state.search.originPlacesFiltered,

        destinationSearch: state => state.search.destinationSearch,
        destinationSearchFocused: state => state.search.destinationSearchFocused,
        destinationPlacesFiltered: state => state.search.destinationPlacesFiltered,

        originPlace: state => state.search.originPlace,
        destinationPlace: state => state.search.destinationPlace,

        formOfTravellerDataFocused: state => state.search.formOfTravellerDataFocused,
        tripType: state => state.search.tripType,
        cabinClass: state => state.search.cabinClass,
        adults: state => state.search.adults,
        children: state => state.search.children,

        isLoading: state => state.search.isLoading,

    }),

    ...mapGetters([
        'outboundDate',
        'inboundDate',
    ]),
  },
  methods:{

      clearWarningMessages(){
          this.$store.commit('setWarningMessages', []);
      },

      clearErrorMessages(){
         this.$store.commit('setErrorMessages', []);
      },

      transformDateToYMD(date){
        return utils.transformDateToYMD(date);
      },

      updateOriginSearch (val) {
          this.$store.commit('setOriginSearch', val);
      },

      updateDestinationSearch (val) {
          this.$store.commit('setDestinationSearch', val);
      },

      updateOutboundDate(date){
          this.$store.commit('setOutboundDate', date);
      },

      updateInboundDate(date){
          this.$store.commit('setInboundDate', date);
          //this.$store.commit('setInboundDate', $event.target.value);
      },

      updateTripType(tripType){
          this.$store.commit('setTripType', tripType);
      },

      updateCabinClass($event){
          this.$store.commit('setCabinClass', $event.target.value);
      },

      updateAdults( num ){
          this.$store.commit('setAdults', this.adults + num);
      },

      addChild(){
          const newChild = {years: null};
          const children =  this.children.concat([newChild]);
          this.$store.commit('setChildren', children);
      },

      removeChild(){
          let childrenCopied = this.children.slice();
          childrenCopied.pop();
          this.$store.commit('setChildren', childrenCopied);
      },

      setChildAge(childIdx, $event){
          const age = +$event.target.value;
          let childrenCopied = JSON.parse( JSON.stringify( this.children ) );
          childrenCopied[childIdx].years = age;
          console.log(JSON.parse( JSON.stringify( childrenCopied ) ))
          this.$store.commit('setChildren', childrenCopied);
      },

      getCabinClassName(cabinClassId){
          return this.cabinClasses[cabinClassId];
      },

      searchPlaces(keyword){

          return api.searchPlaceByKeyword(keyword).catch( err => {

              this.errorMessages = ['查詢地點時發生錯誤，請稍後再嘗試。'];

              console.log(err, err.response)
          });

      },

      changeOriginSearchFocused( isFocused ){
          setTimeout( () => {
              this.$store.commit('setOriginSearchFocused', isFocused);
              if( this.originPlace ) this.updateOriginSearch(`${this.originPlace.place_name} (${this.originPlace.place_id})`);
          }, isFocused ? 0 : 200 );
      },

      searchPlacesForOrigin($event){

        const keyword = $event.target.value;

        this.updateOriginSearch(keyword);

        if(!keyword || !keyword.trim()) return;

        const task = function(){
                        this.searchPlaces(keyword)
                            .then(response => {

                                const data = response.data;

                                this.$store.commit('setOriginPlacesFiltered', data);

                            });
                    }.bind(this);

        clearTimeout(this.timerForOriginSearch);
        this.timerForOriginSearch = setTimeout( task, 200 );

      },

      selectOriginPlace(place){

          this.$store.commit('setOriginSearchFocused', false);
          this.$store.commit('setOriginPlace', place);

      },

      changeDestinationSearchFocused( isFocused ){
          setTimeout( () => {
              this.$store.commit('setDestinationSearchFocused', isFocused);
              if( this.destinationPlace ) this.updateDestinationSearch(`${this.destinationPlace.place_name} (${this.destinationPlace.place_id})`);
          }, isFocused ? 0 : 200 );
      },

      searchPlacesForDestination($event){

        const keyword = $event.target.value;

        this.updateDestinationSearch(keyword);

        if(!keyword || !keyword.trim()) return;

        const task = function(){
                        this.searchPlaces(keyword)
                            .then(response => {

                                const data = response.data;

                                this.$store.commit('setDestinationPlacesFiltered', data);

                            });
                    }.bind(this);

        clearTimeout(this.timerForDestinationSearch);
        this.timerForDestinationSearch = setTimeout( task, 200 );

      },

      selectDestinationPlace(place){

          this.$store.commit('setDestinationSearchFocused', false);
          this.$store.commit('setDestinationPlace', place);

      },

      changeTravellerFocused( isFocused ){
          setTimeout( () => {
              this.$store.commit('setFormOfTravellerDataFocused', isFocused);
          }, isFocused ? 200 : 0 );
      },

      checkQueryConditions(){

        let failedMessages = [];

        if( !this.originPlace || !this.originPlace.place_id ) failedMessages.push('無指定出發地。');
        if( !this.destinationPlace || !this.destinationPlace.place_id ) failedMessages.push('無指定目的地。');
        if( !this.outboundDate ) failedMessages.push('無指定出發日期。');
        if( this.tripType == 'return' && !this.inboundDate ) failedMessages.push('無指定回程日期。');
        if( this.outboundDate ){
            const outboundDate = new Date(this.outboundDate);
            outboundDate.setHours(0);
            if ( outboundDate < this.today ) failedMessages.push('出發日期應晚於等於今日。');
            if ( outboundDate > this.afterOneYear ) failedMessages.push('出發日期不得晚於一年以後。');
        }
        if ( this.inboundDate ) {
            const inboundDate = new Date(this.inboundDate);
            inboundDate.setHours(0);
            if ( inboundDate < this.today ) failedMessages.push('回程日期應晚於等於今日。');
            if ( inboundDate > this.afterOneYear ) failedMessages.push('回程日期不得晚於一年以後。');
            if ( new Date( this.outboundDate ) && inboundDate < new Date( this.outboundDate ) ) failedMessages.push('回程日期不得早於出發日期。');
        }
        if( !this.cabinClass ) failedMessages.push('無指定艙等。');
        if( this.adults + this.children.length === 0 ) failedMessages.push('無指定乘客人數。');
        if( this.children.length > 0 && this.children.filter( child => child.years === null ).length > 0 ) failedMessages.push('無指定孩童年紀。');

        return failedMessages;

      },

      queryPrice(){

          const failedMessages = this.checkQueryConditions();

          this.$store.commit('setWarningMessages', failedMessages);

          if( failedMessages.length > 0 ) return;

          const data = {
            origin_place: this.originPlace.place_id,
            destination_place: this.destinationPlace.place_id,
            outbound_date: utils.transformDateToYMD(this.outboundDate),
            inbound_date: this.tripType == 'return' ? utils.transformDateToYMD(this.inboundDate) : null,
            cabin_class: this.cabinClass,
            adults: this.adults,
            children: this.children.filter( child => child.years >= 1 ).length,
            infants: this.children.filter( child => child.years < 1 ).length,
          };

          this.$store.commit('setIsLoading', true);

          api.queryPrice(data)
            .then( response => {
                const livePrice = response.data.live_price;
                this.$router.push({ path: `search/${livePrice}` });
                this.$store.commit('setIsLoading', false);
          }).catch( err => {

              this.$store.commit('setErrorMessages', []);

              console.log(err, err.response)
          } );

      },

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
